const basico10 = {
    titulo: `JavaScript: estructura repetitiva do while`,
    problemas: [
      {
        codigo: 1,
        descripcion: `La sentencia do/while es otra estructura repetitiva, la cual ejecuta al menos una vez su bloque repetitivo, a diferencia del while que puede no ejecutar el bloque.
<pre>
do {
    // código a ejecutar
} while (condición)
</pre>
Esta estructura repetitiva se utiliza cuando conocemos de antemano que por lo menos una vez se ejecutará el bloque repetitivo. La condición de la estructura está abajo del bloque a repetir, a diferencia del while que está en la parte superior.
Finaliza la ejecución del bloque repetitivo cuando la condición retorna falso, es decir igual que el while.
Mostrar los números del 1 al 10 usando la estructura do/while:
<pre>
let i = 1
do {
  console.log(i)
  i = i + 1
} while (i != 11)
</pre>`,
        programa: `let i = 1
do {
  i = i + 1
} while (i != 11)
console.log(i)`,
        solucion: "11",
      }, {
        codigo: 2,
        descripcion: ``,
        programa: `let suma = 0
let contador = 1
do {
  suma = suma + contador
  contador = contador + 1
} while (contador != 6)
console.log(suma)`,
        solucion: "15",
      }
    ]
  }
  
  export default basico10;